import React from 'react';
import AssessmentForm from '../components/AssessmentForm';

const AssessmentPage: React.FC = () => {
  return <AssessmentForm />;
};

export default AssessmentPage;